import React from "react";
import { useBilling } from "../../store/BillingContext";
import { printDocument, generateDocumentHtml } from "../../lib/pdf";

export const DocumentPreviewModal: React.FC = () => {
  const { previewDoc, setPreviewDoc, state } = useBilling();

  if (!previewDoc) return null;

  const htmlContent = generateDocumentHtml(previewDoc, state);

  return (
    <div className="overlay">
      <div className="modal" style={{ width: "min(950px, 96vw)", height: "92vh" }}>
        <div className="modal-head">
          <h2>Document Preview: {previewDoc.number}</h2>
          <div style={{ display: "flex", gap: "8px" }}>
            <button
              className="primary"
              onClick={() => printDocument(previewDoc, state)}
              style={{ fontSize: "13px", padding: "6px 14px" }}
            >
              <i className="fa-solid fa-print" /> Print / Save PDF
            </button>
            <button
              onClick={() => setPreviewDoc(null)}
              style={{ fontSize: "18px", border: "none", background: "transparent", cursor: "pointer" }}
            >
              ×
            </button>
          </div>
        </div>

        <div className="modal-body" style={{ padding: "0", background: "#525659", display: "flex", justifyContent: "center" }}>
          <iframe
            title="Document Preview"
            srcDoc={htmlContent}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              background: "#ffffff",
              boxShadow: "0 0 20px rgba(0,0,0,0.3)",
            }}
          />
        </div>

        <div className="modal-foot">
          <button onClick={() => setPreviewDoc(null)}>Close Preview</button>
          <button className="primary" onClick={() => printDocument(previewDoc, state)}>
            <i className="fa-solid fa-download" /> Download / Print PDF
          </button>
        </div>
      </div>
    </div>
  );
};
